import { Text } from 'uikit';

import Styles from '../cellRenderer.module.css';

const MATH_MSG = `Для математических действий используйте знаки + - * / ( )`;

const UER_TOOLTIP_MSG = 'Для вызова списка расценок введите знак @ в поле формулы и выберите или введите шифр';
const MTR_TOOLTIP_MSG = 'Для вызова списка расценок или МТР введите знак @ в поле формулы и выберите или введите шифр';

export const getTooltipMessages = (hasEmptyVariablesData = false, isUer = false) => {
    if (isUer) {
        return {
            tooltipMessage: (
                <Text size="xs" className={Styles.textTooltip}>
                    {!hasEmptyVariablesData && <div>{UER_TOOLTIP_MSG}</div>}
                    <div>{MATH_MSG}</div>
                </Text>
            ),
            placeholderMessage: !hasEmptyVariablesData ? `• ${UER_TOOLTIP_MSG} \n• ${MATH_MSG}` : `• ${MATH_MSG}`,
        };
    }

    return {
        tooltipMessage: (
            <Text size="xs" className={Styles.textTooltip}>
                {!hasEmptyVariablesData && <div>{MTR_TOOLTIP_MSG}</div>}
                <div>{MATH_MSG}</div>
            </Text>
        ),
        placeholderMessage: !hasEmptyVariablesData ? `• ${MTR_TOOLTIP_MSG} \n• ${MATH_MSG}` : `• ${MATH_MSG}`,
    };
};
